import { createGlobalStyle } from 'styled-components';

const GlobalStyled = createGlobalStyle`

* {
  box-sizing: border-box;
}

body {
  margin: 0 auto;
}

`

export default GlobalStyled